import { useState } from "react";
import { getCard, listRewardOrganizations } from "../../content/lookups.js";
import { getStageRewardPools } from "../../content/stages.js";
import { CardView } from "../../components/CardView.js";
import { playGameSound } from "../../audio/gameSoundPlayer.js";
import { OrgPoolList } from "../map/OrgPoolList.js";

type PoolTab = "small" | "medium" | "large" | "org";
const POOL_TABS: PoolTab[] = ["small", "medium", "large", "org"];
const POOL_LABELS: Record<PoolTab, string> = { small: "小規模", medium: "中規模", large: "大規模", org: "基盤" };

export function PoolPanel({ stageId }: { stageId?: string }) {
  const [tab, setTab] = useState<PoolTab>("small");
  const pool = tab === "org" ? null : getStageRewardPools(stageId)[tab];
  const cardIds = pool ? [...pool.workers, ...pool.actions] : [];

  return (
    <section className="bring-in-section">
      <h2>報酬プール</h2>
      <div className="pool-panel">
        <div className="bring-in-tabs" role="tablist">
          {POOL_TABS.map((key) => (
            <button
              key={key}
              type="button"
              role="tab"
              aria-selected={tab === key}
              className={`bring-in-tab${tab === key ? " is-active" : ""}`}
              onClick={() => {
                if (tab !== key) playGameSound("ui.select");
                setTab(key);
              }}
            >
              {POOL_LABELS[key]}
            </button>
          ))}
        </div>
        <div className="pool-panel-body">
          {tab === "org" ? (
            <OrgPoolList organizations={listRewardOrganizations(stageId)} />
          ) : (
            <div className="bring-in-card-row">
              {cardIds.map((cardId, index) => {
                const def = getCard(cardId);
                return def ? (
                  <CardView
                    key={cardId}
                    card={{ instanceId: `pool-${tab}-${index}`, cardId }}
                    definition={def}
                    inactive
                    className="bring-in-pool-card"
                  />
                ) : null;
              })}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
